import React from 'react';
import './Rotaryfeatu.css';

import AutomaArm from '../../../imgs/AutomaArm.webp';
import Rotaryaccuracy from '../../../imgs/Rotaryaccuracy.webp';
import Modularot from '../../../imgs/Modularot.webp';
import GoodAppeara from '../../../imgs/Good-Appeara.webp';


const Rotaryfeatu = () => {
  return (
    <div className="rotaryfeatu-wrapper">
      <h2 className="section-title">FEATURES</h2>

      <div className="card-container">
        <div className="cardr"data-aos="flip-down" >
          <img src={AutomaArm} alt="Automatic Product Line" />
          <h3>Automatic Product Line</h3>
          <p>Equipped with the robot for automatic production line to improve efficiency.</p>
        </div>

        <div className="card"data-aos="fade-down" >
          <img src={Rotaryaccuracy} alt="Rotary Accuracy" />
          <h3>Rotary Accuracy</h3>
          <p>The rotary part is controlled by servo motor, which ensures the rotary accuracy.</p>
        </div>

        <div className="card"data-aos="fade-down" >
          <img src={Modularot} alt="Modular Mold Design" />
          <h3>Modular Mold Design</h3>
          <p>Modular design mold structure to reduce the production cost, if the product is changed, just need to change the relative mold parts.</p>
        </div>

        <div className="card"data-aos="fade-down" >
          <img src={GoodAppeara} alt="Good Appearance Finish" />
          <h3>Good Appearance Finish</h3>
          <p>The appearance quality is perfect without parting line, suitable for the industry which is strict for the product appearance.</p>
        </div>
      </div>

     
    </div>
  );
};

export default Rotaryfeatu;
